/* eslint-disable eqeqeq */
import generateVersionHash from '@utils/generateVersionHash';
import axios from 'axios';
import { createListMutations, createListState } from '@utils/storeHelpers';
import api from './constants';
import { postApi } from '../../../../lib/fetcher';


const merchantApi = {
  namespaced: true,
  state: createListState(),
  mutations: createListMutations(),
  actions: {
    async getData(ctx, { date, page, itemsPerPage, search }) {
      const URL_API = api.GET_LIST_MERCHANT_API;

      try {
        if (ctx.state.requestData) ctx.state.requestData.cancel();

        const axiosSource = axios.CancelToken.source();

        ctx.commit('setCancelation', {
          cancel: axiosSource.cancel,
          msg: 'Loading...',
        });

        ctx.commit('clearData');
        ctx.commit('setLoading', true);
     
        const version = generateVersionHash(page.toString() + itemsPerPage.toString(), date);
        const data = JSON.stringify({
          page: page.toString(),
          limit: itemsPerPage.toString(),
          search,
          version
        });

        const addConfig = { cancelToken: axiosSource.token };

        const responseData = await postApi(ctx, URL_API, data, addConfig);

        if (responseData?.code == 200) {
          ctx.commit('setTotalData', { payload: responseData });
          ctx.commit('setData', { payload: responseData });
        }
      } finally {
        ctx.commit('setLoading', false);
      }
    },
  },
};

export default merchantApi;
